:host {
  display: block;
}

.#{$prefix}navigation-main-wrapper {
  position: relative;
  width: 100%;
  height: 64px;
  background-color: $navigation-main-bg-color;
  z-index: 90;

  eon-ui-color-separator {
    position: absolute;
    bottom: -8px;
    z-index: 0;
  }

  .#{$prefix}navigation-main-inner {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: $content-max-width-desktop-l;
    margin: 0 auto 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: stretch;
    z-index: 99;

    @include for-size(desktop-or-smaller) {
      max-width: $content-max-width-desktop;
    }
  }
}

.#{$prefix}toggle-mobile-nav {
  position: relative;
  height: 100%;
  font-family: $font-family-base;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  padding: 24px 8px 24px 8px;
  margin: 0px 8px 0px 8px;
  color: $navigation-main-link-font-color;
  background-color: $navigation-main-link-bg-color;
  text-decoration: none;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  display: none;
  border: 0;

  @include for-size(tablet-or-smaller) {
    display: flex;
  }

  $transition-time: 0.4s;
  $rotation: 45deg;
  $translateY: (16px * 0.5);
  $translateX: 0px;

  // &::after {
  //   content: "";
  //   position: absolute;
  //   left: 0;
  //   bottom: -8px;
  //   width: 100%;
  //   height: 8px;
  //   background-color: $navigation-main-link-border-color;
  // }

  &:hover {
    color: $navigation-main-link-font-color-hover;
    background-color: $navigation-main-link-bg-color-hover !important;

    // &::after {
    //   background-color: $navigation-main-link-border-color-hover;
    // }
  }

  &:focus {
    color: $navigation-main-link-font-color-focus;
    background-color: $navigation-main-link-bg-color-focus !important;
    outline: none;

    // &::after {
    //   background-color: $navigation-main-link-border-color-focus;
    // }
  }

  &.#{$prefix}current {
    color: $navigation-main-link-font-color-current;
    background-color: $navigation-main-link-bg-color-current;

    // &::after {
    //   background-color: $navigation-main-link-border-color-current;
    // }

    &:hover {
      color: $navigation-main-link-font-color-current-hover;
      background-color: $navigation-main-link-bg-color-current-hover;

      // &::after {
      //   background-color: $navigation-main-link-border-color-current-hover;
      // }
    }

    &:focus {
      color: $navigation-main-link-font-color-current-focus;
      background-color: $navigation-main-link-bg-color-current-focus;
      outline: none;

      // &::after {
      //   background-color: $navigation-main-link-border-color-current-focus;
      // }
    }
  }

  &.#{$prefix}active {
    color: $navigation-main-link-font-color-active;
    background-color: $navigation-main-link-bg-color-active;

    // &::after {
    //   background-color: $navigation-main-link-border-color-active;
    // }

    &:hover {
      color: $navigation-main-link-font-color-active-hover;
      background-color: $navigation-main-link-bg-color-active-hover;

      // &::after {
      //   background-color: $navigation-main-link-border-color-active-hover;
      // }
    }

    &:focus {
      color: $navigation-main-link-font-color-active-focus;
      background-color: $navigation-main-link-bg-color-active-focus;
      outline: none;

      // &::after {
      //   background-color: $navigation-main-link-border-color-active-focus;
      // }
    }

    #hamburger-icon {
      .line-1 {
        transform: translateY($translateY) translateX($translateX) rotate($rotation);
        -webkit-transform: translateY($translateY) translateX($translateX) rotate($rotation);
        -moz-transform: translateY($translateY) translateX($translateX) rotate($rotation);
      }

      .line-2 {
        opacity: 0;
      }

      .line-3 {
        transform: translateY($translateY * -1) translateX($translateX) rotate($rotation * -1);
        -webkit-transform: translateY($translateY * -1) translateX($translateX) rotate($rotation * -1);
        -moz-transform: translateY($translateY * -1) translateX($translateX) rotate($rotation * -1);
      }
    }
  }

  #hamburger-icon {
    position: relative;
    width: 24px;
    height: 18px;
    display: block;
    cursor: pointer;

    .line {
      display: block;
      background: $navigation-main-link-font-color;
      width: 24px;
      height: 2px;
      position: absolute;
      left: 0;
      border-radius: (2px * 0.5);
      transition: all $transition-time;
      -webkit-transition: all $transition-time;
      -moz-transition: all $transition-time;

      &.line-1 {
        top: 0;
      }

      &.line-2 {
        top: 50%;
        transform: translateY(-50%);
      }

      &.line-3 {
        bottom: 0;
      }
    }
  }
}
